const { CONFIG } = require('../firebase/config');

const HOST = process.env.REACT_APP_API_URL;
const HOST_NEST = process.env.REACT_APP_NEST_API_URL;
const HOST_PRODUCT = process.env.REACT_APP_PRODUCT_URL;

const FIREBASE = CONFIG;

export { HOST, FIREBASE, HOST_PRODUCT, HOST_NEST };
